import React, { useState, useEffect, useRef } from 'react';
import { db } from '../db/db';
import { useStore } from '../store/useStore';
import { useEnterAsTab } from '../hooks/useEnterAsTab';

export const SalaryComponentCreationView = ({ handleItemSelect, componentId }: any) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const activeCompany = useStore(state => state.activeCompany);
  const [name, setName] = useState('');
  const [type, setType] = useState<'Allowance' | 'Deduction'>('Allowance');
  const [valueType, setValueType] = useState<'Fixed' | 'Percentage'>('Fixed');
  const [percentageValue, setPercentageValue] = useState<number | string>('');

  useEnterAsTab(containerRef);

  useEffect(() => {
    if (componentId) {
      db.salaryComponents.get(componentId).then(it => {
        if (it) {
          setName(it.name);
          setType(it.type);
          setValueType(it.valueType);
          setPercentageValue(it.percentageValue || '');
        }
      });
    }
  }, [componentId]);

  const handleSave = async () => {
    if (!name.trim()) return alert('Name is required');
    if (!activeCompany) return;

    const data = {
      companyId: activeCompany.id!,
      name: name.trim(),
      type,
      valueType,
      percentageValue: valueType === 'Percentage' ? Number(percentageValue) : undefined
    };

    if (componentId) {
      await db.salaryComponents.update(componentId, data);
    } else {
      const exists = await db.salaryComponents.where('[companyId+name]').equals([activeCompany.id!, name.trim()]).first();
      if (exists) { alert('Already exists'); return; }
      await db.salaryComponents.add(data);
    }

    handleItemSelect({ name: 'Quit' });
  };

  return (
    <div
      ref={containerRef}
      className="flex flex-col w-full h-full bg-white z-20 absolute inset-0 font-sans text-[12px] text-black pb-4"
    >
      <div className="bg-[#1e8585] text-white flex justify-between px-2 py-[2px] font-bold shadow-sm z-10">
        <span className="w-1/3 text-left">{componentId ? 'Alter' : 'Create'} Salary Component</span>
        <span className="w-1/3 text-center">{activeCompany?.name}</span>
        <span data-quit-btn className="w-1/3 text-right cursor-pointer hover:text-gray-300" onClick={() => handleItemSelect({ name: 'Quit' })}>✕</span>
      </div>

      <div className="flex-1 overflow-y-auto p-4 flex justify-center">
        <div className="w-[400px] border border-[#aebec8] bg-[#f8f9fa] shadow-sm flex flex-col pt-2 pb-4">
          <div className="px-4 py-2 flex items-center justify-between">
            <span className="font-bold w-[120px]">Name</span>
            <input autoFocus value={name} onChange={e => setName(e.target.value)}
              className="flex-1 border border-black focus:bg-[#ffd] focus:outline-none px-1 h-[20px]" />
          </div>

          <div className="px-4 py-2 flex items-center justify-between">
            <span className="font-bold w-[120px]">Type</span>
            <select value={type} onChange={e => setType(e.target.value as any)}
              className="flex-1 border border-black focus:bg-[#ffd] focus:outline-none px-1 h-[20px]">
              <option value="Allowance">Allowance / Earning</option>
              <option value="Deduction">Deduction</option>
            </select>
          </div>

          <div className="px-4 py-2 flex items-center justify-between">
            <span className="font-bold w-[120px]">Value Type</span>
            <select value={valueType} onChange={e => setValueType(e.target.value as any)}
              className="flex-1 border border-black focus:bg-[#ffd] focus:outline-none px-1 h-[20px]">
              <option value="Fixed">Fixed Amount</option>
              <option value="Percentage">Percentage (of Basic)</option>
            </select>
          </div>

          {valueType === 'Percentage' && (
            <div className="px-4 py-2 flex items-center justify-between">
              <span className="font-bold w-[120px]">Percentage %</span>
              <input type="number" value={percentageValue} onChange={e => setPercentageValue(e.target.value)}
                className="flex-1 border border-black focus:bg-[#ffd] focus:outline-none px-1 h-[20px]" />
            </div>
          )}

          <div className="mt-4 flex justify-between items-center px-4">
            <span className="text-[11px] italic text-gray-400">Ctrl+A / End to save | Esc to cancel</span>
            <button data-save-btn onClick={handleSave} className="px-6 py-1 bg-[#1e8585] text-white font-bold hover:bg-[#1a7070]">Save (End)</button>
          </div>
        </div>
      </div>
    </div>
  );
};
